module.exports = __webpack_public_path__ + "img/005.85572400.jpg";